module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scannerContainer",
    staticClass: "home-page"
  }, [(_vm.qrScannerFocusEnabled && !_vm.isMobile()) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "tm-scanner-card",
    class: {
      'tm-scanner--focused': _vm.isFocusedScanner
    },
    on: {
      "click": _vm.toggleScannerFocus
    }
  }, [_c('div', {
    staticClass: "tm-scanner-header"
  }, [_c('h2', {
    staticClass: "tm-scanner-title"
  }, [_vm._v(_vm._s(_vm.locale.t('scanner_control')))]), _vm._v(" "), _c('span', {
    staticClass: "tm-scanner-status",
    class: _vm.isFocusedScanner ? 'tm-scanner-status--ok' : 'tm-scanner-status--bad'
  }, [_c('span', {
    staticClass: "tm-scanner-status-dot"
  }), _vm._v("\n                " + _vm._s(_vm.isFocusedScanner ? _vm.locale.t('scanner_focus') : _vm.locale.t('scanner_not_focus')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "tm-scanner-controls"
  }, [(!_vm.isFocusedScanner) ? _c('button', {
    staticClass: "tm-scanner-btn",
    class: !_vm.isFocusedScanner ? 'tm-scanner-btn--danger' : 'tm-scanner-btn--success',
    on: {
      "click": _vm.toggleScannerFocus
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isFocusedScanner ? _vm.locale.t('scanner_focus') : _vm.locale.t('focus_scanner')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scannerData),
      expression: "scannerData"
    }],
    ref: "scannerInput",
    staticClass: "tm-scanner-input",
    attrs: {
      "id": "scannerInput",
      "type": "text",
      "placeholder": _vm.locale.t('scanning_in_progress'),
      "autocomplete": "off",
      "spellcheck": "false",
      "name": "priceByUser"
    },
    domProps: {
      "value": (_vm.scannerData)
    },
    on: {
      "focus": _vm.onScannerFocus,
      "blur": _vm.onScannerBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onScannerEnter.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scannerData = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tm-scanner-preview"
  }, [_c('div', {
    staticClass: "tm-scanner-preview-title"
  }, [_vm._v(_vm._s(_vm.locale.t('last_scanned_user')) + ": " + _vm._s((_vm.lastScannerRead || '—')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isEnableBusyProgress) ? _c('div', {
    staticClass: "section-bottom"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('h4', {
    staticClass: "home-busy-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_current_busy')))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top-xs"
  }, [_c('div', {
    staticClass: "progress-bar-style"
  }, [_c('div', {
    staticClass: "progress-container-home"
  }, [_c('div', {
    staticClass: "progress-bar-home",
    style: (_vm.getProgressStyle())
  }, [_vm._v("\n              " + _vm._s(_vm.progressValue > 0 ? "" + _vm.progressValue + "%" : "") + "\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.length > 0) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "scrollmenu home-tabs-scroll"
  }, [(_vm.tabsOnHomePage.includes('NOTIFICATIONS')) ? _c('div', {
    class: _vm.selectedButton === 'NOTIFICATIONS' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('NOTIFICATIONS')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_notifications')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.includes('TRAINING')) ? _c('div', {
    class: _vm.selectedButton === 'TRAINING' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('TRAINING')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_home_trainings')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.includes('TRAINER')) ? _c('div', {
    class: _vm.selectedButton === 'TRAINER' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('TRAINER')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_trainers')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.includes('NUTRITION')) ? _c('div', {
    class: _vm.selectedButton === 'NUTRITION' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('NUTRITION')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_nutrition')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.includes('KNOWLEDGE')) ? _c('div', {
    class: _vm.selectedButton === 'KNOWLEDGE' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('KNOWLEDGE')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_knowledge')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.includes('SHOP') && _vm.role === 'ROLE_USER') ? _c('div', {
    class: _vm.selectedButton === 'SHOP' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('SHOP')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_shop')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.includes('EVENT')) ? _c('div', {
    class: _vm.selectedButton === 'EVENT' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('EVENT')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_events')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tabsOnHomePage.includes('MOBILE_SETTINGS') && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
    class: _vm.selectedButton === 'MOBILE_SETTINGS' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('MOBILE_SETTINGS')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_mobile_settings')) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-container home-header-margin"
  }, [(_vm.selectedButton === 'NOTIFICATIONS' && (_vm.isAdmin() || _vm.enableAddNotification)) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('NOTIFICATIONS')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_notification')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'TRAINING' && _vm.isAdmin()) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('TRAINING')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_ci_training_add')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'TRAINER' && _vm.isAdmin()) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('TRAINER')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_ci_trainer_add')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'NUTRITION' && _vm.isAdmin()) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('NUTRITION')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_ci_nutrition_add')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'KNOWLEDGE' && _vm.isAdmin()) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('KNOWLEDGE')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_ci_knowledge_add')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'SHOP' && _vm.isAdmin()) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('SHOP')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_ci_shop_add')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'EVENT' && _vm.isAdmin()) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('EVENT')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_ci_event_add')) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.selectedButton === 'NOTIFICATIONS') ? _c('div', {
    staticClass: "trainer-grid"
  }, _vm._l((_vm.notifications), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "flex-container-notif notif-card-pad"
    }, [(item.imageUrl != null) ? _c('div', {
      staticClass: "flex-container-notif-left"
    }, [_c('div', {
      staticClass: "ci-notification-picture w-full",
      style: ('background-image: url(' + item.imageUrl + ');')
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex-container-notif-right notif-content-pad",
      style: (item.imageUrl != null ? 'width: 69%;' : 'width: 99%;')
    }, [_c('div', [_c('p', {
      staticClass: "notif-title"
    }, [_vm._v(_vm._s(_vm.getTitle(item)) + "\n                "), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.enableAddNotification) ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editNotification(item.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.enableAddNotification) ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNotification(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e()]), _vm._v(" "), (item.trainingTypes != null) ? _c('div', {
      staticClass: "notif-text-text"
    }, [_c('p', {
      staticClass: "section-bottom-xs"
    }, [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.trainingTypes))])])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "limited-lines-3 ci-desc-text"
    }, [_vm._v("\n                " + _vm._s(_vm.getText(item)))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-left",
      staticStyle: {
        "margin-top": "4px",
        "width": "100%",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "read-more-container action-container-width",
      on: {
        "click": function($event) {
          return _vm.editNotification(item.id)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.displayDate(item.createdTime).day) + ". " + _vm._s(_vm.displayDate(item.createdTime).month) + "\n                ")]), _vm._v(" "), (item.link !== null && item.link.length > 0) ? _c('div', {
      staticClass: "open-link-container",
      staticStyle: {
        "width": "80px",
        "margin-left": "10px"
      }
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('u', [_vm._v(_vm._s(_vm.locale.t("label_link")))]), _vm._v(" "), _c('i', {
      staticClass: "ti-new-window"
    })])]) : _vm._e(), _vm._v(" "), (item.priority === 'HIGH') ? _c('div', {
      staticClass: "important-container",
      staticStyle: {
        "width": "80px",
        "margin-left": "10px"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("label_important")) + "\n                ")]) : _vm._e()])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'TRAINING') ? _c('div', {
    staticClass: "training-grid"
  }, _vm._l((_vm.trainings), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "ci-training-main"
    }, [_c('div', {
      staticClass: "ci-training-overlay"
    }), _vm._v(" "), _c('div', {
      staticClass: "ci-training",
      style: ('background-image: url(' + item.imageHeader + '); opacity: 0.4;')
    }), _vm._v(" "), _c('div', {
      staticClass: "ci-trainer-content"
    }, [_c('div', {
      staticClass: "c2 discount-margin"
    }, [_c('p', {
      staticClass: "notif-title",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n                "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'TRAINING')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      class: item.hidden ? 'button-disabled' : 'button-enabled',
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [(item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_hide.svg")
      }
    }) : _vm._e(), _vm._v(" "), (!item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_visible.svg")
      }
    }) : _vm._e()]) : _vm._e()]), _c('br'), _vm._v(" "), (item.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
      staticClass: "notif-text-text"
    }, [_c('p', {
      staticClass: "location-badge"
    }, [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.locations))])])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "home-training-subtitle"
    }, [_vm._v("-" + _vm._s(_vm.getCompanyInfoShort(item)) + "-")]), _vm._v(" "), _c('p', {
      staticClass: "home-training-description"
    }, [_vm._v(_vm._s(_vm.getMaxChars(_vm.getCompanyInfoLong(item), 100)) + "...")]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-space-between section-top-xs",
      staticStyle: {
        "width": "95%"
      }
    }, [_c('div', {
      staticClass: "ci-training-button"
    }, [_c('img', {
      staticClass: "icon-xs",
      attrs: {
        "src": require("../../assets/img/icons/infos/training/time.svg")
      }
    }), _vm._v("\n                  " + _vm._s(_vm.convertAdditionalInfo(item.additionalInfo).minutes) + "min\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "ci-training-button"
    }, [_c('img', {
      staticClass: "icon-xs",
      attrs: {
        "src": require("../../assets/img/icons/infos/training/kcal.svg")
      }
    }), _vm._v(_vm._s(_vm.convertAdditionalInfo(item.additionalInfo).kcal) + "kcal\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "ci-training-button"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageForIntesity(_vm.convertAdditionalInfo(item.additionalInfo).intensity)
      }
    })])])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'TRAINER') ? _c('div', {
    staticClass: "trainer-grid"
  }, _vm._l((_vm.trainers), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "flex-container-trainer"
    }, [_c('div', {
      staticClass: "flex-container-trainer-left"
    }, [_c('div', {
      staticClass: "ci-trainer-picture",
      style: ('background-image: url(' + item.imageMain + ');')
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-trainer-right"
    }, [_c('p', {
      staticClass: "notif-title"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n              "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'TRAINER')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      class: item.hidden ? 'button-disabled' : 'button-enabled',
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [(item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_hide.svg")
      }
    }) : _vm._e(), _vm._v(" "), (!item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_visible.svg")
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (item.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
      staticClass: "notif-text-text"
    }, [_c('p', {
      staticClass: "section-bottom-xs"
    }, [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.locations))])])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "ci-desc-text-xl"
    }, [_vm._v("\n              " + _vm._s(_vm.getMaxChars(_vm.getCompanyInfoLong(item), 200)))])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'NUTRITION') ? _c('div', {
    staticClass: "trainer-grid"
  }, _vm._l((_vm.nutritions), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "flex-container-trainer"
    }, [_c('div', {
      staticClass: "flex-container-trainer-left"
    }, [_c('div', {
      staticClass: "ci-trainer-picture",
      style: ('background-image: url(' + item.imageMain + ');')
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-trainer-right"
    }, [_c('p', {
      staticClass: "notif-title"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n              "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'NUTRITION')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      class: item.hidden ? 'button-disabled' : 'button-enabled',
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [(item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_hide.svg")
      }
    }) : _vm._e(), _vm._v(" "), (!item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_visible.svg")
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (item.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
      staticClass: "notif-text-text"
    }, [_c('p', {
      staticClass: "section-bottom-xs"
    }, [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.locations))])])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "ci-desc-text-xl"
    }, [_vm._v("\n              " + _vm._s(_vm.getMaxChars(_vm.getCompanyInfoLong(item), 200)))])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'KNOWLEDGE') ? _c('div', {
    staticClass: "trainer-grid"
  }, _vm._l((_vm.knowledges), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "flex-container-trainer"
    }, [_c('div', {
      staticClass: "flex-container-trainer-left"
    }, [_c('div', {
      staticClass: "ci-trainer-picture",
      style: ('background-image: url(' + item.imageMain + ');')
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-trainer-right"
    }, [_c('p', {
      staticClass: "notif-title"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n              "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'KNOWLEDGE')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      class: item.hidden ? 'button-disabled' : 'button-enabled',
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [(item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_hide.svg")
      }
    }) : _vm._e(), _vm._v(" "), (!item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_visible.svg")
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (item.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
      staticClass: "notif-text-text"
    }, [_c('p', {
      staticClass: "section-bottom-xs"
    }, [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.locations))])])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "ci-desc-text-xl"
    }, [_vm._v(_vm._s(_vm.getMaxChars(_vm.getCompanyInfoLong(item), 200)))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "home-info-button-selected",
      on: {
        "click": function($event) {
          return _vm.previewKnowledge(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_preview')))]), _vm._v(" "), _c('span', {
      staticClass: "home-info-button-selected",
      on: {
        "click": function($event) {
          return _vm.copyToNotification(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_copy_to_notification')))])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'SHOP') ? _c('div', {
    staticClass: "trainer-grid"
  }, [_vm._l((_vm.shopsActions), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "flex-container-trainer"
    }, [_c('div', {
      staticClass: "flex-container-trainer-left"
    }, [_c('div', {
      staticClass: "ci-trainer-picture",
      style: ('background-image: url(' + item.imageMain + ');')
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-trainer-right"
    }, [_c('p', {
      staticClass: "notif-title"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n              "), (_vm.convertAdditionalInfo(item.additionalInfo).discount != null && _vm.convertAdditionalInfo(item.additionalInfo).discount > 0) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v("\n                -" + _vm._s(_vm.convertAdditionalInfo(item.additionalInfo).discount) + "%\n              ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'SHOP')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      class: item.hidden ? 'button-disabled' : 'button-enabled',
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [(item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_hide.svg")
      }
    }) : _vm._e(), _vm._v(" "), (!item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_visible.svg")
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "ci-desc-text-shop"
    }, [_vm._v("\n              " + _vm._s(_vm.getMaxChars(_vm.getCompanyInfoLong(item), _vm.isMobile() ? 50 : 100)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1px",
        "width": "100%",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "home-price-row"
    }, [_c('s', {
      staticClass: "badge-text"
    }, [_vm._v(_vm._s(item.addInfo.price))]), _vm._v(" "), _c('b', {
      staticClass: "shop-price-strike"
    }, [_vm._v(_vm._s(item.discountPrice))]), _vm._v(" "), _c('b', {
      staticClass: "shop-price-strike"
    }, [_vm._v(_vm._s(item.addInfo.currency))])])]), _vm._v(" "), (_vm.enableShopAndOrder) ? _c('div', [_c('span', {
      staticClass: "home-info-button-selected",
      on: {
        "click": function($event) {
          return _vm.buyShopItem(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_buy')))])]) : _vm._e()])])])
  }), _vm._v(" "), _vm._l((_vm.shops), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "flex-container-trainer"
    }, [_c('div', {
      staticClass: "flex-container-trainer-left"
    }, [_c('div', {
      staticClass: "ci-trainer-picture",
      style: ('background-image: url(' + item.imageMain + ');')
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-trainer-right"
    }, [_c('p', {
      staticClass: "notif-title"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n              "), (_vm.convertAdditionalInfo(item.additionalInfo).discount != null && _vm.convertAdditionalInfo(item.additionalInfo).discount > 0) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v("\n                -" + _vm._s(_vm.convertAdditionalInfo(item.additionalInfo).discount) + "%\n              ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'SHOP')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      class: item.hidden ? 'button-disabled' : 'button-enabled',
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [(item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_hide.svg")
      }
    }) : _vm._e(), _vm._v(" "), (!item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_visible.svg")
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (item.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('div', {
      staticClass: "notif-text-text"
    }, [_c('p', {
      staticClass: "section-bottom-xs"
    }, [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.locations))])])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "ci-desc-text-xl",
      staticStyle: {
        "height": "50px"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getMaxChars(_vm.getCompanyInfoLong(item), _vm.isMobile() ? 50 : 100)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1px",
        "width": "100%",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "home-price-row"
    }, [_c('b', [_vm._v(" " + _vm._s(item.addInfo.price) + " " + _vm._s(item.addInfo.currency))])])]), _vm._v(" "), (_vm.enableShopAndOrder) ? _c('div', [_c('span', {
      staticClass: "home-info-button-selected",
      on: {
        "click": function($event) {
          return _vm.buyShopItem(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_buy')))])]) : _vm._e()])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'EVENT') ? _c('div', {
    staticClass: "trainer-grid"
  }, _vm._l((_vm.events), function(item, index) {
    return _c('div', {
      staticClass: "notif-main"
    }, [_c('div', {
      staticClass: "flex-container-trainer"
    }, [_c('div', {
      staticClass: "flex-container-trainer-left"
    }, [_c('div', {
      staticClass: "ci-trainer-picture",
      style: ('background-image: url(' + item.imageMain + ');')
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-container-trainer-right"
    }, [_c('p', {
      staticClass: "notif-title"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n              "), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button margin-left-xs clickable",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'EVENT')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_edit.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('i', {
      staticClass: "new-button clickable",
      class: item.hidden ? 'button-disabled' : 'button-enabled',
      staticStyle: {
        "margin-left": "2px"
      },
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [(item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_hide.svg")
      }
    }) : _vm._e(), _vm._v(" "), (!item.hidden) ? _c('img', {
      staticClass: "icon-visibility",
      attrs: {
        "src": require("../../assets/img/icons/ic_visible.svg")
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "ci-desc-text-shop"
    }, [_vm._v("\n              " + _vm._s(_vm.getMaxChars(_vm.getCompanyInfoLong(item), _vm.isMobile() ? 50 : 100)))]), _vm._v(" "), _c('div', [(_vm.role === 'ROLE_SUPER_ADMIN') ? _c('span', {
      staticClass: "home-info-button-selected",
      on: {
        "click": function($event) {
          return _vm.signUpForEvent(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_ci_event_sign_up')))]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('span', {
      staticClass: "home-info-button-selected",
      on: {
        "click": function($event) {
          return _vm.allEventItems(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_ci_event_all_users')))]) : _vm._e()])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedButton === 'MOBILE_SETTINGS') ? _c('div', {
    staticClass: "foo"
  }, [(_vm.allCustomCategories.length > 0) ? _c('div', [_c('div', {
    staticClass: "scrollmenu home-location-scroll"
  }, [_c('label', {
    staticClass: "form-label home-location-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_location')))]), _vm._v(" "), _vm._l((_vm.allCustomCategories), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectCustomCategory(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n                                ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2)]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "text-reader"
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_load_image')) + " ( "), _c('b', [_vm._v("max 5MB")]), _vm._v(") "), _c('i', {
    staticClass: "ti-upload"
  }), _vm._v(" "), _c('input', {
    ref: "fileInput1",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.loadTextFromFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "phone-container"
  }, [_c('div', {
    staticClass: "phone"
  }, [_c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "section-top"
  }, [_c('label', {
    staticClass: "text-reader"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_ci_header_image_info_desc_1'))), _c('br'), _vm._v(_vm._s(_vm.locale.t('label_ci_header_image_info_desc_2')) + "\n              ")])]), _vm._v(" "), (_vm.selectedHeaderImagePreview != null) ? _c('div', {
    staticClass: "foo pp-header-image"
  }, [_c('div', {
    staticClass: "ci-training",
    style: ('background-image: url(' + _vm.selectedHeaderImagePreview + ');border-radius: 0;')
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedHeaderImagePreview == null && _vm.imageHeaderUrl != null) ? _c('div', {
    staticClass: "foo pp-header-image"
  }, [_c('div', {
    staticClass: "ci-training",
    style: ('background-image: url(' + _vm.imageHeaderUrl + '); border-radius: 0;')
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top-xs"
  }, [(_vm.selectedHeaderImagePreview != null || _vm.imageHeaderUrl != null) ? _c('div', {
    staticClass: "new-button",
    staticStyle: {
      "background-color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.deletePhoto()
      }
    }
  }, [_c('i', {
    staticClass: "ti-trash"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_delete")) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "new-button section-top-xs",
    on: {
      "click": function($event) {
        return _vm.uploadPhoto()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "home-button"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showNoNotification && _vm.selectedButton === 'NOTIFICATIONS') ? _c('div', [_c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/ic_no_notifications.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "no-data-text"
  }, [_vm._v("\n          " + _vm._s(_vm.locale.t('label_no_data_notifications')) + "\n        ")])])]) : _vm._e(), _vm._v(" "), _c('show-qr-code-dialog', {
    attrs: {
      "show": _vm.showQrCodeItem != null,
      "item": _vm.showQrCodeItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e3ab05a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/HomePage.vue
// module id = 810
// module chunks = 0